import React, { useEffect, useState } from 'react';

import './customCheckbox.scss';
import { CheckOutlined } from '@ant-design/icons';
import classNames from 'classnames';

export const CustomCheckbox = ({ onChange, isChecked = false, id = 'default-checkbox' }) => {
  const [isSelected, setIsSelected] = useState(isChecked || false);

  useEffect(() => {
    setIsSelected(isChecked);
  }, [isChecked]);

  const handleCheckboxChange = (e) => {
    setIsSelected(e.target.checked);
    if (onChange) onChange(e.target.checked);
  };

  const inputStyles = classNames('custom-checkbox__input', {
    'custom-checkbox__input--selected': isSelected,
  });

  return (
    <div className="custom-checkbox">
      <label htmlFor={id} className="custom-checkbox__label">
        <input
          id={id}
          type="checkbox"
          className={inputStyles}
          required
          checked={isSelected}
          onChange={handleCheckboxChange}
        />
        {isSelected && (
          <div className="custom-checkbox__icon">
            <CheckOutlined />
          </div>
        )}
      </label>
    </div>
  );
};
